import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {WarningModalComponent} from './warning-modal.component';
import {take} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WarningModalService extends ModalService {
    testModal() {
        this.createModalComponent(WarningModalComponent);
        this.showModalComponent();
    }

    createWarningMessage(message: string, title: string, modalSize?: 'sm' | 'md' | 'lg') {
        this.createModalComponent(WarningModalComponent);
        const warningModalComponentInstance = this.modalComponentRef.instance as WarningModalComponent;

        if (title) {
            warningModalComponentInstance.setTitle(title);
        }

        if (message) {
            warningModalComponentInstance.setMessage(message);
        }

        return this.createWarning(modalSize);
    }

    createWarning(modalSize: 'sm' | 'md' | 'lg' = 'md') {
        if (this.modalOpen) {
            console.debug('Modal already opened.');
            return null;
        } else {
            const warningModalComponentInstance = this.modalComponentRef.instance as WarningModalComponent;
            this.modalComponentRef.setInput('modalSize', `modal-${modalSize}`);

            this.showModalComponent();
            return warningModalComponentInstance.modalClosed.pipe(take(1));
        }
    }
}
